<div class="buttons-wrapper">
  <button mat-button color="primary" (click)="setForUser()">{{'wizard.installUser' | translate}}</button>
  <button mat-button color="primary" (click)="setForGroup()">{{'wizard.installUnit' | translate}}</button>
  <button mat-button color="primary" (click)="setForAll()">{{'wizard.installForAll' | translate}}</button>
</div>
